interface AlternativeTranslationConfig {
  settingCategory: string;
  settingName: string;
  settingValue: string;
  transKey: string;
}

type CountrySpecificTranslationConfig = Record<
  string,
  AlternativeTranslationConfig
>;

export const COUNTRY_SPECIFIC_TRANSLATION_CONFIG: CountrySpecificTranslationConfig =
  {
    insurance: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'insurance_pl',
    },
    insurance_amount: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'insurance_amount_pl',
    },
    insurance_fee: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'insurance_fee_pl',
    },
    full_insurance_title: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'full_insurance_title_pl',
    },
    full_insurance_description: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'full_insurance_description_pl',
    },
    basic_insurance_title: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'basic_insurance_title_pl',
    },
    basic_insurance_description: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'basic_insurance_description_pl',
    },
    insurance_modal_title: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'insurance_modal_title_pl',
    },
    insurance_modal_description: {
      settingCategory: 'shipment_creation_flow',
      settingName: 'insurance_name',
      settingValue: 'compensations',
      transKey: 'insurance_modal_description_pl',
    },
  };
